import React, { memo } from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import * as yup from 'yup';
import useFormSubmit from 'hooks/useFormSubmit';
import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormTextField from 'components/ui/form/FormTextField';

const validationSchema = yup.object({
  message: yup
    .string()
    .trim()
    .required('crm.smsBulk.validation.messageRequired'),
});

export default memo(function SmsBulkModal({ open, setOpen, leads }) {
  const { t } = useTranslation();
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      message: '',
    },
    validationSchema,
    onSubmit: async (values) => {
      if (!leads?.length) return;
      const body = {
        message: values.message,
        leads: leads.map((l) => l.id),
      };
      submit(
        { type: 'post', contentType: 'simple' },
        body,
        '/crm/crm-lead/send-sms-bulk',
        'send sms bulk',
        null,
        true,
        () => {
          setOpen(null);
          formik.resetForm();
        },
      );
    },
  });

  const onClose = () => {
    setOpen(null);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='lg'
      PaperProps={{ className: '!base-border !shadow-none !overflow-hidden' }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!bg-[#CDCDCDC7] !text-center !border-b !border-b-[#E6E6E6]'
      >
        <span className='pr-5 font-semibold text-[21px] text-[#374957]'>
          {t('crm.smsBulk.title')}
        </span>
      </DialogTitle>
      <div className='py-4 px-8 min-w-[600px]'>
        <form onSubmit={formik.handleSubmit}>
          <div className='flex justify-center flex-col gap-4'>
            <FormTextField
              delay={0}
              label={t('crm.smsBulk.message')}
              fieldName='message'
              rows={5}
              multiline={true}
              formik={formik}
            />
            <div className='text-xs text-gray-500'>
              {formik.values.message?.length || 0} {t('crm.smsBulk.charCount')}
            </div>
            <div className='flex justify-between items-center'>
              <div>
                {t('sidebar.admin.lead')}: {leads?.length}
              </div>
              <FormActionButtons
                delay={0}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  );
});
